import { render, staticRenderFns } from "./MarronsIntro.vue?vue&type=template&id=f0bb7866&"
import script from "./MarronsIntro.vue?vue&type=script&lang=js&"
export * from "./MarronsIntro.vue?vue&type=script&lang=js&"
import style0 from "./MarronsIntro.vue?vue&type=style&index=0&id=f0bb7866&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports